import { personInfoFrag } from '../../../../utils/type/person.common-type';
import { userInfoFrag } from '../../../../utils/type/user.common-type';
import { workParticipantsFrag } from '../../../../services/types/work.types';

const offersFrag = `
    offers {
        id
        offerId
        payByCredits
        applications
        operations
        procedures
        dateFrom
        dateTo
        durationNote
        durationPreparation
        durationSelfReflection
        tags
        areas
        users
        executions
        note
        presence
        type
        serviceOffer {
            code
            name
            color
        }
        targets {
            targetId
            folderId
        }
    }
`;

export const getFolderByPersonFrag = `
    id
    serviceId
    personId
    person {
        ${personInfoFrag}
    }
`;

export const getWorkDetailFrag = `
    id
    workType
    serviceId
    dateFrom
    dateTo
    folderId
    isBilled
    users {
        ${userInfoFrag}
    }
    tags
    workData {
        ... on WorkDataGroupActivityObject {
            note
            form
        }
    }
    personId
    ${offersFrag}
    relatedWorks {
        id
        workType
        folderId
        ${offersFrag}
        personId
        ${workParticipantsFrag}
        workData {
            ... on WorkDataGroupActivityItemObject {
                id
            }
            ... on WorkDataOperationalReportObject {
                type
                priority
                description
                users {
                    ${userInfoFrag}
                }
            }
        }
    }
`;
